import type { RetailerLocation } from '~/composables/useRetailerLocations';
import { getDistanceKm } from '~/util/distance';
import type { LatLng } from '~/util/distance';

export const DISPLAY_RADIUS_KM = 40;

export type DisplayStore = RetailerLocation & { distanceKm: number };

/**
 * Retailers that have the product as a display sample, nearest first
 */
export const getDisplayStores = (displayStoreIds: string[], retailers: RetailerLocation[], from: LatLng): DisplayStore[] => {
  const wanted = new Set(displayStoreIds.map(id => id.toLowerCase()));

  return retailers
    .filter(r => wanted.has(r.accountid.toLowerCase()))
    .map(r => ({ ...r, distanceKm: getDistanceKm(from, r) }))
    .sort((a, b) => a.distanceKm - b.distanceKm);
};
